import React from 'react'

import * as S from './styles.js'

export default function RegistrationWelcome() {
  return (
    <S.Container>
      <S.Title fontSize="60px">Bem-vindo a Virtueyes!</S.Title>

      <S.ParagraphStrong>
        Falta pouco para você aproveitar a conectividade IoT de quem entende do
        assunto e ainda ter à sua disposição uma plataforma de gestão como o
        V.EYE.
      </S.ParagraphStrong>

      <S.Paragraph2>
        Em instantes você receberá um e-mail de confirmação de cadastro para
        poder acessar a plataforma V.EYE. Caso não esteja na sua caixa de
        entrada, confira sua caixa de Spam.
      </S.Paragraph2>

      <S.Paragraph2>
        Lembre-se: para a criação do seu usuário, o código promocional que
        recebeu poderá ser usado apenas uma vez. Caso tenha dificuldades, nosso
        time está à disposição para ajudar pelo telefone/WhatsApp: (51)
        3562-1777 ou por e-mail: duvidas.simcardevento@virtueyes.com.br.
      </S.Paragraph2>
    </S.Container>
  )
}
